import React, {useState} from 'react';
import {AppBar, TitlePortal, useStoreContext, useNotify} from 'react-admin';
import {useLocation, useNavigate} from 'react-router-dom';
import { makeStyles } from "@mui/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
    box: {
        height:"15px", width:"20%"
    },
    smallBox: {
        height:"15px", width:"10%"
    },
    resetButton: {
        marginRight: 8,
    },
});
const MyAppBar = props => {
    const classes = useStyles();
    const store = useStoreContext();
    const notify = useNotify();
    const location = useLocation();
    const navigate = useNavigate();
    const [confirmOpen, setConfirmOpen] = useState(false);

    const resetAll = () => {
        store.reset();
        // Strip any saved filter/sort/pagination params from the URL so the
        // reset is visible immediately and isn't re-applied on the next visit.
        navigate(location.pathname, { replace: true });
        setConfirmOpen(false);
        notify('Filters and saved settings have been reset', { type: 'success' });
    };

    return (
        <>
            <AppBar  {...props}>
                <TitlePortal/>
                <Tooltip title="Clear all saved filters, sorting, pagination and other remembered settings">
                    <Button
                        className={classes.resetButton}
                        variant="contained"
                        color="primary"
                        size="small"
                        startIcon={<RestartAltIcon/>}
                        onClick={() => setConfirmOpen(true)}
                    >
                        Reset Filters
                    </Button>
                </Tooltip>
            </AppBar>
            <Dialog
                open={confirmOpen}
                onClose={() => setConfirmOpen(false)}
                aria-labelledby="reset-filters-dialog-title"
            >
                <DialogTitle id="reset-filters-dialog-title">Reset saved filters and settings?</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        This clears every remembered filter, sorting order, pagination and other saved settings
                        across the app. You will stay logged in.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmOpen(false)} color="primary">Cancel</Button>
                    <Button onClick={resetAll} color="primary" variant="contained" autoFocus>Reset</Button>
                </DialogActions>
            </Dialog>
            <Box display="flex" >

                <Box  display="flex" style={{backgroundColor:"#74bb00"}} className={classes.box}>

                </Box>
                <Box  display="flex" style={{backgroundColor:"#000"}} className={classes.smallBox}>

                </Box>

               <Box  display="flex"  style={{backgroundColor:"#ffae0d"}} className={classes.box}>

               </Box>

                <Box  display="flex" style={{backgroundColor:"#d94c00"}} className={classes.box}>

                </Box>

                <Box  display="flex" style={{backgroundColor:"#000"}} className={classes.smallBox}>

                </Box>

                <Box  display="flex" style={{backgroundColor:"#fff"}} className={classes.smallBox}>

                </Box>
                <Box  display="flex" style={{backgroundColor:"#0d7aff"}} className={classes.smallBox}>

                </Box>


            </Box>
            </>
    );
};

export default MyAppBar;
